/**
 * @typedef {{
 *  media: HTMLMediaElement,
 *  url?: string,
 *  isLive?: boolean,
 *  softDecode?: boolean,
 *  targetLatency?: number,
 *  maxLatency?: number,
 *  bufferBehind?: number,
 *  maxJumpDistance?: number,
 *  startTime?: number,
 *  retryCount?: number,
 *  retryDelay?: number,
 *  loadTimeout?: number,
 *  preloadTime?: number,
 *  disconnectTime?: number,
 *  fetchOptions?: RequestInit
 * }} HlsOption
 */

/**
 * @param {HlsOption} opts
 * @returns {HlsOption}
 */
export function getOption (opts) {
  return {
    retryCount: 3,
    retryDelay: 1000,
    loadTimeout: 10000,
    preloadTime: 10,
    softDecode: false,
    bufferBehind: 10,
    maxJumpDistance: 3,
    startTime: 0,
    ...opts
  }
}
